export default "__VITE_ASSET__352a5ffa__"